
import { NavigationClient } from "@azure/msal-browser";
import { BackgroundColor, InAppBrowser, ToolBarType } from '@capgo/inappbrowser';
import { Capacitor } from "@capacitor/core";
import { Device } from '@capacitor/device';
import { Configuration, PublicClientApplication } from "@azure/msal-browser";
import { App, URLOpenListenerEvent } from '@capacitor/app';



// Set to true to enable logging
//
const doLogging = false;


function detectAndLogError(url: string) {
  try {
    // Split the URL to get the fragment part (after '#')
    const fragment = url.split('#')[1];

    if (fragment) {
      // Create a URLSearchParams object from the fragment
      const params = new URLSearchParams(fragment);

      // Extract error and error description
      const error = params.get('error');
      const errorDescription = params.get('error_description');

      if (error) {
        console.error('Error detected during redirect:', decodeURIComponent(error));
        if (errorDescription) {
          console.error('Error description:', decodeURIComponent(errorDescription));
        }
        return true;
      }
    }
  } catch (e) {
    console.error('Failed to parse the URL:', e);
  }
  return false;
}


class CustomNavigationClient extends NavigationClient {


  public get PassWordResetRequest() {
    return {
      authority: "https://GrowthLenses.b2clogin.com/tfp/GrowthLenses.onmicrosoft.com/B2C_1_growthlenses_password_reset",
      scopes: [
        "https://GrowthLenses.onmicrosoft.com/API/user.readwrite",
        "https://GrowthLenses.onmicrosoft.com/API/shared.readonly"
      ]
    }
  }

  public async GetConfiguration(): Promise<Configuration> {


    doLogging && console.log("GetConfiguration");
    if (!this.configuration) {
      var redirectUri = "";
      var info = await Device.getInfo();
      switch (info.platform) {
        case "ios":
          redirectUri = "msauth.com.growthlenses.journal://auth";
          break;
        case "android":
          redirectUri = "msauth://com.growthlenses.journal/%2FBSNnjQz%2FKTX1pBpZl35Nui3DSM%3D";
          break;
        case "web":
          redirectUri = `${window.location.origin}/redirect`; // Points to window.location.origin. You must register this URI on Microsoft Entra admin center/App Registration.
          break;
      }

      this.configuration = {
        auth: {
          clientId: "d8f6ae7d-f455-427a-8b99-7cde12afbae1",
          authority: "https://GrowthLenses.b2clogin.com/tfp/GrowthLenses.onmicrosoft.com/B2C_1_growthlenses_signup_signin",
          knownAuthorities: ["GrowthLenses.b2clogin.com"],
          redirectUri: redirectUri
        },

        cache: {
          cacheLocation: "localStorage",
          storeAuthStateInCookie: false,
          secureCookies: false
        },
        // system: {
        //   loggerOptions: {
        //     logLevel: LogLevel.Verbose,
        //     loggerCallback: (level, message, containsPii) => {
        //       if (containsPii) {
        //         return;
        //       }
        //       switch (level) {
        //         case LogLevel.Error:
        //           console.error(message);
        //           return;
        //         case LogLevel.Info:
        //           console.info(message);
        //           return;
        //         case LogLevel.Verbose:
        //           console.debug(message);
        //           return;
        //         case LogLevel.Warning:
        //           console.warn(message);
        //           return;
        //       }
        //     },
        //     piiLoggingEnabled: false
        //   },
        // },
      }
    }

    doLogging && console.log("Configuration", this.configuration);
    return this.configuration;
  }

  public get isNative() { return Capacitor.isNativePlatform; }







  public clearCookies = () => {
    if (this.lastUrl !== "") {
      InAppBrowser.clearCookies({ url: this.lastUrl });
      this.lastUrl = "";
    }
  }






  async navigateExternal(url: string, options: any) {

    var resolver: (value: void | PromiseLike<void>) => void;
    this._externalNavigatePromise = new Promise<void>(async (resolve, _reject) => {
      resolver = resolve;
    });

    doLogging && console.log("navigateExternal", this.stripHash(url));
    if (Capacitor.isNativePlatform()) {
      this.lastUrl !== "" && console.warn(`Last url was not cleared: ${this.lastUrl}`);
      this.lastUrl = url;

      InAppBrowser.removeAllListeners();
      InAppBrowser.openWebView({
        url: url,
        isAnimated: true,
        isPresentAfterPageLoad: true,
        toolbarType: ToolBarType.BLANK,
        backgroundColor: BackgroundColor.WHITE
      });

      InAppBrowser.addListener('urlChangeEvent', async (event) => {

        await this.tryRedirect(event.url);
        resolver && resolver();
      });
    } else {
      if (options.noHistory) {
        window.location.replace(url);
      } else {
        window.location.assign(url);
      }
    }
    return true;
  }
  public get externalNavigatePromise() { return this._externalNavigatePromise; }
  private _externalNavigatePromise: Promise<void> | undefined = undefined;






  private async tryRedirect(redirectUrl: string) {

    doLogging && console.log("========================= tryRedirect ======================");
    var didRedirect = false;

    if (redirectUrl.includes(this.configuration?.auth.redirectUri!)) {
      //
      // Close the in app browser and redirect to localhost + the state parameter
      //
      await InAppBrowser.close();

      const url = redirectUrl.replace(this.configuration?.auth.redirectUri!, this.origin);
      window.location.href = url;

      doLogging && console.log('redirect request to:', this.stripHash(redirectUrl));
      doLogging && console.log('will redirect to:', this.stripHash(url));
      doLogging && console.log("Handling redirect as part of webview redirect");
      await this.handleRedirect();

      didRedirect = true;
    }

    return didRedirect;
  }







  public constructor() {
    super();
    this.initializePromise = this.Initialize();

    App.addListener('appUrlOpen', async (event: URLOpenListenerEvent) => {
      //
      // Android calls us back via a deep link, we need to handle it here.
      //
      doLogging && console.log("CustomNavClient - appUrlOpen - " + event.url)
      if (!detectAndLogError(event.url)) {
        doLogging && console.log("CustomNavClient - appUrlOpen - no error detected, trying redirect")
        await this.tryRedirect(event.url);
      }
      doLogging && console.log("CustomNavClient - appUrlOpen - finsihed")

    });
  }







  private async handleRedirect() {

    try {
      var hash = window.location.hash;
      this.redirectPromise = this.pca!.handleRedirectPromise(hash);
      var response = await this.redirectPromise;
      if (response !== null) {
        window.location.assign("/"); // Navigate away from the redirect page after processing
      }
      else {
        doLogging && console.log("Redirect promise was null");
      }
    }
    catch (error: any) {
      if (error.errorMessage.startsWith("AADB2C90118")) {
        console.warn("Handle reset password");
      } else {
        console.error(error);

      }
    }
  }







  private async Initialize() {

    doLogging && console.log("Initializing CustomNavigationClient");
    await this.privateGetPCA();
    doLogging && console.log("Handling redirect as part of initialization");
    await this.handleRedirect();

    doLogging && console.log(`${new Date().toISOString()} > CustomNavigationClient Initialized`);


  }






  private privateGetPCA = async (): Promise<void> => {

    doLogging && console.log("privateGetPCA");
    var config = await this.GetConfiguration();

    if (this.pca) {
      doLogging && console.log("Clearing Cache");
      this.pca.clearCache();
    }

    doLogging && console.log("Creating PCA");
    var pca = new PublicClientApplication(config);

    doLogging && console.log("PCA Created");
    const authPromise = pca.initialize();
    pca.setNavigationClient(this);

    doLogging && console.log("PCA Navigation Client Set");
    await authPromise;

    doLogging && console.log("PCA Initialized");
    this.pca = pca;


  }






  ClearCookies = async () => {

    if (this.initializePromise) {
      doLogging && console.log("Waiting for initialization");
      await this.initializePromise;
    }

    doLogging && console.log("ClearCookies");
    this.pca?.clearCache();

  }






  GetPCA = async (overrideCache = false): Promise<PublicClientApplication> => {

    doLogging && console.log("GetPCA", overrideCache);

    if (this.initializePromise) {
      doLogging && console.log("Waiting for initialization");
      await this.initializePromise;
    }
    if (overrideCache) {
      this.pca?.clearCache();
      await this.privateGetPCA();
    }

    this.redirectPromise && await this.redirectPromise;


    return this.pca!;
  }




  private stripHash = (url: string) => url.split('#')[0] + '# < * >';




  private lastUrl = "";
  private pca: PublicClientApplication | undefined = undefined;
  private redirectPromise: Promise<any | null> | undefined = undefined;
  private origin = window.location.origin;
  private initializePromise: Promise<void> | undefined = undefined;
  private configuration?: Configuration;
}
export const GLNavClient = new CustomNavigationClient();


